module.exports = __webpack_public_path__ + "img/cardamom.f2cc0777.png";